export enum ChartType {
  BAR = 'BAR',
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
  LINE = 'LINE',
  AREA = 'AREA',
  PIE = 'PIE',
  DONUT = 'DONUT',
  STACKED_BAR = 'STACKED_BAR',
  GROUPED_BAR = 'GROUPED_BAR',
  HISTOGRAM = 'HISTOGRAM',
  KPI = 'KPI'
}

export enum ChartAggregation {
  COUNT = 'COUNT',
  SUM = 'SUM',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX'
}

export enum ChartSort {
  VALUE_DESC = 'VALUE_DESC',
  VALUE_ASC = 'VALUE_ASC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export enum ChartDateBucket {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR'
}

export const CHART_OTHER_KEY = '__other__';
export const CHART_EMPTY_KEY = '__empty__';

/** What to chart; figures always come from {@link ChartData}. */
export interface ChartSpec {
  chartType: ChartType;
  title?: string;
  rationale?: string;
  dimension?: string;
  dateBucket?: ChartDateBucket;
  series?: string;
  measure?: string;
  aggregation: ChartAggregation;
  topN?: number;
  sort?: ChartSort;
}

export interface ChartCategory {
  key: string;
  label: string;
}

export interface ChartSeries {
  key: string;
  label?: string;
  values: Array<number | null>;
}

export interface ChartKpi {
  aggregation: ChartAggregation;
  label?: string;
  value: number | null;
}

export interface ChartData {
  categories: ChartCategory[];
  series: ChartSeries[];
  kpis: ChartKpi[];
  grain: 'DOCUMENT' | 'OCCURRENCE';
  otherIncluded: boolean;
  approximate: boolean;
}

/** Translated labels for the reserved category keys and the row-count series. */
export interface ChartLabels {
  other: string;
  empty: string;
  count: string;
}
